<template>
  <app-logged id="VinculosDetails">
    <v-flex xs12>
      <app-widget class-widget="xs12">
        <div slot="widget-content">
          <v-list-item three-line>
            <v-list-item-content>
              <div
                class="overline mb-4"
                v-text="`vínculos indústria/cliente`"
              />
              <v-list-item-title
                class="headline font-weight-medium mb-1"
                v-text="industria.nome_fantasia"
              />
              <v-list-item-subtitle
                class="font-weight-medium"
                v-text="Message.registro(filtredEventos.length)"
              />
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                v-if="eventos.length"
                @click="update"
                small
                color="success"
              >
                atualizar
                <v-icon
                  right
                  small
                  color="white"
                >
                  cached
                </v-icon>
              </v-btn>
              <div class="d-flex flex-row align-center">
                <v-chip
                  v-if="!desligado && eventos.length"
                  label
                  @click="desligado = !desligado"
                  class="my-2 mr-2"
                  color="grey darken-2"
                  outlined
                >
                  Exibir clientes desligados
                  <v-icon class="ml-1">
                    check_box_outline_blank
                  </v-icon>
                </v-chip>
                <v-chip
                  v-if="desligado && eventos.length"
                  @click="desligado = !desligado"
                  label
                  class="my-2 mr-2"
                  color="warning"
                  outlined
                >
                  <div class="black--text">
                    Exibir clientes desligados
                  </div>
                  <v-icon class="ml-1">
                    check_box
                  </v-icon>
                </v-chip>
                <v-chip
                  label
                  class="my-2"
                  color="primary darken-2"
                  outlined
                >
                  <div class="black--text">
                    Período:
                    <strong class="ml-1">{{
                      $options.filters.jurisdiction(periodoAtual)
                    }}</strong>
                  </div>
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="periodoAtual"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        class="ml-2"
                      >
                        <v-icon color="primary">
                          edit_calendar
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-date-picker
                      v-model="date"
                      type="month"
                      scrollable
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="modal = false"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-chip>
              </div>
            </v-list-item-action>
          </v-list-item>
          <v-skeleton-loader
            type="list-item-three-line"
            v-if="loading"
          />
          <v-simple-table
            dense
            v-if="!loading && filtredEventos.length > 0"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Cliente
                  </th>
                  <th class="text-center">
                    Foto
                  </th>
                  <th class="text-center">
                    Indicadores
                  </th>
                  <th class="text-center">
                    Balancete
                  </th>
                  <th class="text-center">
                    Laudo
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in filtredEventos"
                  :key="index"
                  @click="edit(item.id)"
                >
                  <td>
                    {{ item.cliente_nome }}
                    <v-tooltip
                      right
                      v-if="item.contrato.contrato_fim"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          x-small
                          color="warning"
                          v-bind="attrs"
                          v-on="on"
                        >
                          warning
                        </v-icon>
                      </template>
                      <span>Cliente já desligado</span>
                    </v-tooltip>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getBooleanColor(item.foto)"
                      small
                    >
                      {{ getBooleanIcon(item.foto) }}
                    </v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getBooleanColor(item.indicadores)"
                      small
                    >
                      {{ getBooleanIcon(item.indicadores) }}
                    </v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getBooleanColor(item.balancete)"
                      small
                    >
                      {{ getBooleanIcon(item.balancete) }}
                    </v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getBooleanColor(item.laudo)"
                      small
                    >
                      {{ getBooleanIcon(item.laudo) }}
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-card-text
            class="d-flex flex-column align-center"
            v-if="!loading && filtredEventos.length === 0"
          >
            <v-row>
              <span>Nenhum evento foi registrado para esse período.</span>
            </v-row>
            <v-row class="mt-4">
              <v-btn
                class="primary"
                @click="create"
              >
                criar eventos
              </v-btn>
            </v-row>
          </v-card-text>
        </div>
      </app-widget>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import Message from '@/plugins/message'
export default {
  name: 'VinculosDetails',
  components: {
    AppWidget,
    AppLogged
  },
  data () {
    return {
      Message,
      date: null,
      modal: false,
      loading: false
    }
  },
  watch: {
    periodoAtual (val, old) {
      this.loading = true
      this.atualizarEventos(val, this.desligado)
    }
  },
  computed: {
    ...mapGetters(['eventos', 'industria']),
    filtredEventos () {
      return (this.desligado) ? this.eventos : this.eventos.filter(item => !item.contrato.contrato_fim)
    },
    periodoAtual: {
      get () {
        return this.$store.getters.competencia
      },
      set (val) {
        return this.$store.commit('setCompetencia', val)
      }
    },
    desligado: {
      get () {
        return this.$store.getters.desligado
      },
      set (val) {
        return this.$store.commit('setDesligado', val)
      }
    }
  },
  methods: {
    ...mapActions(['getEventos', 'postSaveEventos']),
    async atualizarEventos (periodo) {
      try {
        await this.getEventos({ periodo, industria: this.industria.id })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    getBooleanIcon (value) {
      return value ? 'check_circle' : 'remove_circle'
    },
    getBooleanColor (value) {
      return value ? 'success' : 'error'
    },
    async update () {
      if (confirm('Registros de eventos para clientes ativos não listados abaixo poderão ser criados. Deseja continuar?')) {
        await this.postSaveEventos({ periodo: this.periodoAtual })
        return this.atualizarEventos(this.periodoAtual)
      }
    },
    async create () {
      await this.postSaveEventos({ periodo: this.periodoAtual })
      return this.atualizarEventos(this.periodoAtual)
    },
    edit (id) {
      return this.$router.push({
        name: 'controle-eventos-update',
        params: {
          id: Number(id),
          industria: Number(this.$route.params.id)
        }
      })
    }
  }
}
</script>
